import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../../CloudStorage/CloudStorage";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addproposaltowishlist } from "../../../../../../../redux/posts/action";
import PostNotFound from "../../../../../../CustomComponents/AllLoader/PostNotFound";
import ViewProfilePopup from "../../../../../../Common/ViewProfilePopup";
import ProjectHireRequestModel from "../../../../../../Common/ProjectHireRequestModel";
import { hitPostChat } from "../../../../../../../redux/chatandnotification/action";
import ProfilePic from "../../../../../../../assests/imgs/Profileplaceholder.svg";
import RoleLabel from "../../../../../../Common/RoleLabel";
import CustomReactQuillDescription from "../../../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";

export default function MineProjectShortlisted({ posts, directpayment }) {
  const [loading, setLoading] = useState(false);
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  // const [proposal, setProposal] = useState([]);
  const [modal, setModal] = useState(false);
  const [profiledetails, setprofiledetails] = useState(false);
  const [modal1, setModal1] = useState(false);
  const [proid, setproid] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [filteredProposals, setFilteredProposals] = useState([]);

  const hireExpert = (id) => {
    setModal1(true);
    setproid(id);
  };
  const comformhireExpert = (id) => {
    navigate(`/${lan}/projectcontract/${id}`);
  };
  const letChat = (item) => {
    const data = {
      post_id: posts?.id,
      user_id: item?.user_id,
    };
    const hitcatapidata = {
      type: "1",
      post_id: posts?.id,
      user_id: item?.user_id,
      message: "",
      image: "",
    };

    // dispatch(hitPostChat(hitcatapidata, setLoading));
    navigate(`/${lan}/account/chats/`, { state: { userdetails: data } });
  };

  const saveToWishlist = (id) => {
    dispatch(addproposaltowishlist(id, posts?.id));
  };

  // useEffect(() => {
  //   setProposal(posts?.proposal || []);
  // }, [posts]);

  useEffect(() => {
    const filteredProposals =
      posts?.proposal?.filter((item) => item.wishlist == 1) || [];
    setFilteredProposals(filteredProposals);
  }, [posts]);

  const viewprofile = (item) => {
    setModal(true);
    setprofiledetails(item);
  };

  return (
    <div className="project-section project-details p-0">
      {modal && (
        <ViewProfilePopup
          profiledetails={profiledetails}
          setModal={setModal}
          modal={modal}
          comformhireExpert={comformhireExpert}
        />
      )}
      {modal1 && (
        <ProjectHireRequestModel
          posts={posts}
          setModal1={setModal1}
          modal1={modal1}
          proid={proid}
        />
      )}

      <div className="post-details">
        <div className="all-proposal-row">
          {Array.isArray(filteredProposals) && filteredProposals.length > 0 ? (
            filteredProposals.map((item, index) => (
              <div className="all-proposal" key={index}>
                <div className="proposal-first">
                  <div
                    className="proposal-left"
                    onClick={() => viewprofile(item)}
                  >
                    <img src={item?.profile_image ? item?.profile_image : ProfilePic} />
                    <div>
                      <h5>
                        {item?.first_name} {item?.last_name}
                        <span>
                          <i className="fa-solid fa-star"></i>
                          {item?.expert_rating || 0} ({item?.expert_comment_count || 0} reviews)
                        </span>
                      </h5>
                      <p>{item?.designation}</p>
                    </div>
                  </div>

                  <div className="expert-right">
                    <button
                      className="btn message-btn"
                      onClick={() => {
                        letChat(item);
                      }}
                    >
                      Chat with <RoleLabel role_type={item?.role_type} />
                    </button>
                    <button
                      disabled={item?.status != "1"}
                      className="btn message-btn active"
                      onClick={() => {
                        comformhireExpert(item?.id);
                      }}
                    >
                      {item?.status == 2
                        ? "You declined"
                        : item?.status == 3
                          ? "Offer Send"
                          : item?.status == 4
                            ? "Offer decline"
                            : item?.status == 5
                              ? "Offer Accepted by User"
                              : "Send Offer"}
                    </button>

                    {
                      (item?.status != "1" && item?.milestones[0]?.payment_status == 0) &&
                      <button
                        className="btn message-btn active"
                        onClick={() => {
                          directpayment(item);
                        }}
                      >
                        Pay
                      </button>
                    }
                    <button
                      className="btn menu-btn"
                      onClick={() => {
                        saveToWishlist(item?.id);
                      }}
                    >
                      {item.wishlist == 1 ? (
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`}
                          alt=""
                        />
                      ) : (
                        <img
                          src={`${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`}
                          alt=""
                        />
                      )}
                    </button>
                  </div>
                </div>
                <h3>Cover letter</h3>
                <p className="cover-p"><CustomReactQuillDescription value={item?.message} /></p>
                <div className="photoshop">
                  {Array.isArray(item?.skills) &&
                    item.skills.map((skill, index) => (
                      <p key={index}>{skill?.title}</p>
                    ))}
                </div>
              </div>
            ))
          ) : (
            <PostNotFound title={"No Shortlisted User"} />
          )}
        </div>
      </div>
    </div>
  );
}
